export default "__VITE_ASSET__DmMkW99y__"